import styled, { CSSProperties } from 'styled-components';
import { flexCenter } from '@/styles/layout';
import { COLORS } from '@/styles/colors';

export const IconWrapper = styled.div<{ backgroundColor?: CSSProperties['backgroundColor'] }>`
  ${flexCenter};
  width: 28px;
  height: 28px;
  border-radius: 28px;
  background-color: ${COLORS.orange[100]};

  ${({ backgroundColor }) =>
    backgroundColor &&
    `
      background-color: ${backgroundColor};
    `};
`;
